export { default } from './OktaWidgetWraper';
